/*
 * @Author: LZH
 * @Date: 2023-04-03 10:43:52
 * @LastEditors: Do not edit
 * @LastEditTime: 2025-04-11 17:56:10
 * @Description:
 */
export default {
  Problem_feedback: 'Ingrese un problema y una sugerencia',
  contact_information: 'Por favor introduzca la información de contacto contacto',
  contact_information_the: 'Por favor introduzca la información de contacto',
  import: 'Entrada',
  Please_enter: 'Por favor introduzca',
  Old_password: 'Contraseña anterior',
  New_password: 'Nueva contraseña',
  Required: 'Obligatorio',
  Enteranewpassword: 'Introduzca una nueva contraseña',
  Confirm_new_password: 'Confirmar nueva contraseña',
  mobile: 'Número de teléfono móvil',
  QQ: 'Número de QQ',
  postbox: 'Buzón de correo',
  contact_you: 'Fácil de contactarle',
  question: 'Por favor introduzca su pregunta',
  Characters_up: '6 y 16 caracteres',
  address: 'Por favor introduzca una dirección detallada',
  renewal_contact: 'Por favor introduzca la información de contacto de renovación',
  ple_contact_name: 'Por favor introduzca el nombre de contacto',
  Please_enter_withdrawal: 'Por favor introduzca el retiro',
  Number_of_cards: 'Número de tarjetas',
  Pleasechooseanagent: 'Por favor elija un agente',
  Pleaseenterthequantity: 'Por favor marque la cantidad',
  Pleaseentertheuserprefixnickname: 'Introduzca el apodo del prefijo de usuario (2-26 dígitos)',
  PleaseEnterImei: 'Introduzca el número IMEI de 15 dígitos',
  Remarkswithin: 'Observaciónes: dentro de 100 palabras',
  Pleaseselectaunit: 'Seleccione una empresa',
  Pleaseselectagrouptojoin: 'Seleccione un grupo al que unirse',
  Pleaseentertheunitname: 'Introduzca el nombre de la empresa',
  companynamerequired: '(Obligatorio: 4-20 caracteres, letras y números)',
  Pleaseenterloginaccount: 'Introduzca la cuenta de inicio de sesión',
  loginaccountrequired: '(Obligatorio 6 a 20 letras y números)',
  Pleaseenteryourpassword: 'Introduzca su contraseña de inicio de sesión',
  loginpasswordrequired: '(Obligatorio: 6 a 16 letras y números)',
  Pleaseenteracontactname: 'Introduzca el nombre de contacto',
  contactnamerequired: '(Obligatorio: 2 a 20, caracteres, letras y números)',
  Pleaseenteraprefixname: 'Introduzca el nombre de perfijo',
  prefixnamerequired: '(Obligatorio: 2-12 caracteres, letras y números)',
  Contactnamerequired20: 'Nombre de contacto (obligatorio 2 a 20 caracteres)',
  mobilephonenumber: 'Número de teléfono móvil (opcional)',
  Enteremailaddress: 'Introduzca la correo electrónico (opcional)',
  Enterdetailedaddress: 'Introduzca la dirección detallada (opcional)',
  Pleaseenteragroupname: 'Introduzca un nombre de grupo (obligatorio 2 a 15 caracteres)',
  Groupnamerequired: 'Nombre de grupo (obligatorio: 2-15 caracteres)',
  Pleasetypeyourphonenumber: 'Por favor introduzca su número de teléfono',
  Pleaseinputtheemailaddress: 'Por favor introduzca la dirección, dirección de correo electrónico',
  Pleaseenterthemailingaddress: 'Por favor introduzca la dirección postal',
  RequiredPleaseenterusernickname: '(Obligatorio) por favor introduzca el nombre de usuario',
  Pleasemobilephonenumber: '(Opcional) por favor en todos casos número de teléfono móvil',
  PleaseentertheoriginalIMEInumber: 'Por favor introduzca el número de IMEI original de 15 dígitos',
  PleaseenterthenewIMEInumber: 'Por favor introduzca el nuevo número de IMEI de 15 dígitos',
  Pleaseenteraverificationcode: 'Por favor introduzcan un código de verificación de 4 dígitos',
  Pleaseenterthemobilephonenumbertobebound: 'Por favor introduzca el número de teléfono móvil que se va a vincular',
  PleaseenteragroupnameTow: 'Por favor introduzca el nombre de grupo',
  Pleaseenterusername: 'Por favor introduzca el nombre de usuario',
  Fencenamerequired: 'Nombre de la valla (obligatorio 1- 15 caracteres)',
  Pleaseenterthefencename: 'Por favor introduzca el nombre de la valla',
  Pleaseselectatime: 'Por favor seleccione una hora',

  please_rest_password: 'Hola, para la seguridad de su cuenta, se recomienda restablecer primero la contraseña de inicio de sesión.',
  TheLastGroupUnderTheUnitCannotBeDeleted: 'El último grupo de la unidad no se puede eliminar.',
}
